import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";

export default function useFindUser() {
  const [user, setUser] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const location = useLocation();
  const { instance } = useMsal();

  const findUser = async () => {
    let activeUser = instance.getActiveAccount();
    if (activeUser) {
      let roles = ['ROLE_VIEWER'];
      let projects = [];
      if (!activeUser.idTokenClaims || !activeUser.idTokenClaims.roles) {
        console.warn('The user has no roles. Logging out.');
        toast.error('You do not have any roles for this application. Please contact your admin.');
        setUser(null);
        localStorage.removeItem('userData');
      } else {
        activeUser.idTokenClaims.roles.forEach(role => {
          if (role && role.startsWith("ROLE_")) {
            roles.push(role);
          } else if (role && role.startsWith("PROJECT_")) {
            projects.push(role.substring(8));
          }
        });
        activeUser.roles = roles;
        activeUser.projects = projects;
        console.log(activeUser);
        setUser({
          ...activeUser,
          isAdmin: activeUser.roles.includes('ROLE_ADMIN'),
        });
        await axios
            .post('/auth/register', activeUser)
            .then((res) => {
              localStorage.setItem(
                  'userData',
                  JSON.stringify(res.data)
              );
            })
            .catch((err) => {
              let errorMsg = err?.response?.data?.error || err.message;
              if (location.state === undefined && location.pathname !== '/login') {
                toast.error(`${errorMsg}`, {
                  position: toast.POSITION.TOP_LEFT,
                });
              }
              setUser(null);
              localStorage.removeItem('userData');
            })
            .finally(() => {
              setLoading(false);
            });
      }
    } else {
      console.log('unable to register without activeUser');
    }
  };

  useEffect(() => {
    findUser();
  }, []);

  return {
    user,
    setUser,
    isLoading,
    setLoading,
    findUser,
  };
}
